// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-secrets {
  color: var(--text-color);
  min-width: 0;
}

.team-secrets-header {
  align-items: flex-end;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  gap: 24px;
  justify-content: space-between;
  margin-bottom: 18px;
  padding-bottom: 16px;
}

.team-secrets-header h2,
.secret-detail-header h3 {
  font-family: var(--font-display);
  margin: 2px 0 4px;
}

.team-secrets-header h2 {
  font-size: 1.55rem;
}

.team-secrets-header p,
.secret-detail-header p {
  color: var(--secondary-text-color);
  margin: 0;
}

.team-secrets-header > button,
.secret-grant-control > button {
  background: var(--button-primary-bg);
  border: 1px solid var(--button-primary-bg);
  border-radius: var(--radius-sm);
  color: var(--button-primary-text);
  cursor: pointer;
  flex: 0 0 auto;
  font-weight: 600;
  padding: 9px 15px;
}

.agent-secrets-header-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.agent-secrets-header-actions button {
  margin: 0;
  width: auto;
}

.agent-secrets-header-actions button:not(.lightButton) {
  background: var(--button-primary-bg);
  border: 1px solid var(--button-primary-bg);
  color: var(--button-primary-text);
}

.agent-secret-ledger {
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  overflow: hidden;
}

.agent-secret-row {
  align-items: center;
  background: var(--card-background);
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(180px, 0.8fr) minmax(280px, 1.4fr) auto;
  padding: 16px;
}

.agent-secret-row + .agent-secret-row {
  border-top: 1px solid var(--danger-border);
}

.agent-secret-identity {
  min-width: 0;
}

.agent-secret-identity > a,
.agent-secret-identity > .secret-name-button {
  display: inline-block;
  margin-right: 8px;
  max-width: 100%;
}

.secret-name-button {
  background: transparent;
  border: 0;
  color: var(--link-color);
  cursor: pointer;
  margin: 0;
  padding: 0;
  text-align: left;
  width: auto;
}

.secret-name-button:hover code {
  text-decoration: underline;
}

.agent-secret-identity code,
.secret-approval-field code {
  color: var(--text-color);
  font-family: var(--font-mono);
  font-weight: 650;
  overflow-wrap: anywhere;
}

.agent-secret-identity p {
  color: var(--secondary-text-color);
  font-size: 0.82rem;
  margin: 7px 0 0;
}

.agent-secret-policy {
  display: grid;
  gap: 7px;
}

.agent-secret-destination {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.agent-secret-actions button {
  margin: 0;
  white-space: nowrap;
  width: auto;
}

.secret-approval-ledger {
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  display: grid;
  gap: 10px;
  margin: 12px 0;
  padding: 12px;
}

.secret-approval-comparison {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.secret-approval-comparison > div {
  background: var(--surface-2);
  border-radius: var(--radius-sm);
  display: grid;
  gap: 8px;
  padding: 10px;
}

.secret-approval-field > span {
  color: var(--secondary-text-color);
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.secret-approval-field p {
  margin: 3px 0 0;
  white-space: pre-wrap;
}

.secret-eyebrow {
  color: var(--secondary-text-color);
  display: block;
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.secret-search {
  margin-bottom: 18px;
}

.secret-search label {
  color: var(--secondary-text-color);
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.secret-search > div {
  display: flex;
  gap: 8px;
}

.secret-search input {
  flex: 1;
  margin: 0;
  min-width: 0;
}

.secret-search .lightButton,
.secret-row-actions .lightButton,
.secret-row-actions .delete-button,
.secret-detail-actions .lightButton,
.secret-detail-actions .delete-button,
.secret-access-row .lightButton,
.secret-load-more {
  margin: 0;
  width: auto;
}

.secret-master-detail {
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  display: grid;
  grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
  min-height: 510px;
  overflow: hidden;
}

.secret-list-rail {
  background: var(--card-background);
  border-right: 1px solid var(--border-color);
  min-width: 0;
}

.secret-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.secret-list-ledger {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  overflow: hidden;
}

.secret-list li + li {
  border-top: 1px solid var(--border-color);
}

.secret-list-item {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 0;
  color: var(--text-color);
  cursor: pointer;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(220px, 1.25fr) minmax(240px, 1fr) minmax(
      150px,
      0.55fr
    );
  margin: 0;
  padding: 16px;
  text-align: left;
  transition: background-color 150ms ease;
  width: 100%;
}

.secret-list-item:hover {
  background: var(--card-hover);
}

.secret-list-item.selected {
  background: var(--accent-tint);
}

.secret-list-primary {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.secret-list-name,
.secret-list-meta,
.secret-destination-strip,
.secret-row-actions,
.secret-modal-actions,
.secret-retention-row > span,
.secret-retention-override > span {
  align-items: center;
  display: flex;
}

.secret-list-name {
  gap: 8px;
  justify-content: flex-start;
  min-width: 0;
  width: 100%;
}

.secret-list-meta {
  align-items: flex-end;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  text-align: right;
}

.secret-list-name code,
.secret-detail-header code,
.secret-history-row code,
.secret-name-preview code,
.secret-policy-track code,
.secret-ledger-grid code,
.secret-version-table code {
  color: var(--text-color);
  font-family: var(--font-mono);
}

.secret-list-name code {
  font-size: 0.84rem;
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
}

.secret-version-chip,
.secret-state-chip {
  background: var(--surface-2);
  border: 1px solid var(--border-color);
  border-radius: 999px;
  color: var(--secondary-text-color);
  font-family: var(--font-mono);
  font-size: 0.67rem;
  padding: 2px 7px;
  white-space: nowrap;
}

.secret-state-chip.current {
  background: var(--accent-tint);
  color: var(--accent-tint-text);
}

.secret-alias-hint {
  color: var(--link-color);
  font-size: 0.72rem;
}

.secret-list-description {
  color: var(--secondary-text-color);
  display: -webkit-box;
  font-size: 0.82rem;
  line-height: 1.35;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.secret-destination-strip {
  flex-wrap: wrap;
  gap: 4px;
}

.secret-destination-chip {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 999px;
  color: var(--secondary-text-color);
  font-family: var(--font-mono);
  font-size: 0.62rem;
  max-width: 100%;
  overflow: hidden;
  padding: 3px 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.secret-destination-chip b {
  color: var(--text-color);
  font-family: var(--font-body);
  font-weight: 600;
}

.secret-list-meta {
  color: var(--secondary-text-color);
  font-family: var(--font-mono);
  font-size: 0.62rem;
  justify-content: center;
  width: auto;
}

.secret-detail-ledger {
  background: var(--background-color);
  min-width: 0;
  padding: 15px 18px 22px;
}

.secret-back-link {
  background: transparent;
  border: 0;
  color: var(--link-color);
  cursor: pointer;
  display: none;
  margin: 0 0 10px;
  padding: 0;
  width: auto;
}

.secret-detail-placeholder,
.secret-state {
  color: var(--secondary-text-color);
}

.secret-detail-placeholder {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 50px;
  text-align: center;
}

.secret-detail-placeholder > span {
  color: var(--border-strong);
  font-family: var(--font-display);
  font-size: 3rem;
}

.secret-detail-placeholder p {
  max-width: 390px;
}

.secret-state {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 28px 20px;
  text-align: center;
}

.secret-detail-header {
  align-items: flex-start;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.secret-detail-header h3 {
  font-size: 1.2rem;
}

.secret-detail-header p {
  font-size: 0.88rem;
}

.secret-detail-actions,
.secret-modal-actions,
.secret-row-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.secret-tabs {
  border-bottom: 1px solid var(--border-color);
  display: flex;
  gap: 2px;
  margin-top: 18px;
  overflow-x: auto;
}

.secret-tabs button {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: var(--secondary-text-color);
  cursor: pointer;
  flex: 0 0 auto;
  font-size: 0.8rem;
  margin: 0;
  padding: 9px 10px 8px;
  width: auto;
}

.secret-tabs button.active {
  border-bottom-color: var(--link-color);
  color: var(--text-color);
  font-weight: 600;
}

.secret-detail-body {
  min-width: 0;
  padding-top: 18px;
}

.secret-ledger-grid {
  display: grid;
  gap: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0;
}

.secret-ledger-grid > div {
  border-bottom: 1px solid var(--border-color);
  min-width: 0;
  padding: 12px;
}

.secret-ledger-grid dt,
.secret-policy-node span,
.secret-policy-state span,
.secret-history-row > span,
.secret-name-preview span {
  color: var(--secondary-text-color);
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.secret-ledger-grid dd {
  font-size: 0.88rem;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.secret-history-row {
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 13px 12px;
}

.secret-history-row code {
  background: var(--card-background);
  border-radius: var(--radius-sm);
  font-size: 0.72rem;
  padding: 4px 7px;
}

.secret-retention-row {
  align-items: center;
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  display: flex;
  gap: 18px;
  justify-content: space-between;
  margin-top: 24px;
  padding: 14px;
}

.secret-retention-row label {
  font-weight: 600;
}

.secret-retention-row p {
  color: var(--secondary-text-color);
  font-size: 0.76rem;
  margin: 3px 0 0;
}

.secret-retention-row > span,
.secret-retention-override > span {
  color: var(--secondary-text-color);
  gap: 7px;
}

.secret-retention-row input,
.secret-retention-override input {
  margin: 0;
  width: 88px;
}

.secret-policy-rail {
  display: grid;
  gap: 12px 0;
  grid-template-columns: minmax(112px, 0.7fr) minmax(180px, 2fr) minmax(
      130px,
      1fr
    );
  margin-top: 20px;
  position: relative;
}

.secret-section-actions {
  align-items: center;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  display: flex;
  gap: 18px;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 14px;
}

.secret-danger-zone {
  border-top: 1px solid var(--border-color);
  margin-top: 40px;
  padding-top: 20px;
}

.secret-danger-zone-heading {
  margin: 0 0 10px;
  color: var(--danger-text);
}

.secret-danger-zone p {
  margin: 0 0 14px;
  max-width: 620px;
}

.secret-danger-zone button {
  margin: 0;
  width: auto;
}

.secret-policy-node,
.secret-policy-track,
.secret-policy-state {
  border-bottom: 1px solid var(--border-color);
  border-top: 1px solid var(--border-color);
  min-width: 0;
  padding: 13px;
}

.secret-policy-node {
  background: var(--accent-tint);
  border-left: 1px solid var(--border-color);
  border-radius: var(--radius-sm) 0 0 var(--radius-sm);
  display: flex;
  flex-direction: column;
}

.secret-policy-node strong {
  color: var(--accent-tint-text);
}

.secret-policy-node em {
  color: var(--secondary-text-color);
  font-size: 0.7rem;
  font-style: normal;
  margin-top: 3px;
}

.secret-policy-track {
  align-items: flex-start;
  background: var(--card-background);
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.secret-policy-track::before,
.secret-policy-track::after {
  background: var(--border-strong);
  content: '';
  height: 1px;
  position: absolute;
  top: 50%;
  width: 12px;
}

.secret-policy-track::before {
  left: -1px;
}
.secret-policy-track::after {
  right: -1px;
}

.secret-policy-track code {
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: 999px;
  font-size: 0.7rem;
  max-width: 100%;
  overflow: hidden;
  padding: 4px 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.secret-policy-state {
  border-right: 1px solid var(--border-color);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.secret-policy-state strong {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  margin-top: 3px;
}

.secret-grant-control {
  align-items: end;
  border-bottom: 1px solid var(--border-color);
  display: grid;
  gap: 7px;
  grid-template-columns: minmax(0, 1fr) auto;
  padding-bottom: 16px;
}

.secret-grant-control label {
  grid-column: 1 / -1;
  font-weight: 600;
}

.secret-grant-control select {
  min-width: 0;
}

.secret-access-row {
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 13px 0;
}

.secret-access-row > div {
  display: flex;
  flex-direction: column;
}

.secret-access-row span {
  color: var(--secondary-text-color);
  font-size: 0.75rem;
}

.secret-version-table-wrap {
  max-width: 100%;
  overflow-x: auto;
}

.secret-version-table {
  border-collapse: collapse;
  font-size: 0.74rem;
  min-width: 790px;
  width: 100%;
}

.secret-version-table th,
.secret-version-table td {
  border-bottom: 1px solid var(--border-color);
  padding: 10px 8px;
  text-align: left;
  vertical-align: middle;
}

.secret-version-table th {
  color: var(--secondary-text-color);
  font-size: 0.65rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.secret-version-table td:last-child {
  text-align: right;
}

.secret-row-actions {
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.secret-row-actions button {
  font-size: 0.68rem;
  padding: 5px 8px;
}

.secret-activity-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.secret-activity-list li {
  align-items: center;
  border-bottom: 1px solid var(--border-color);
  display: grid;
  gap: 10px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  padding: 11px 4px;
}

.secret-activity-mark {
  background: var(--link-color);
  border: 3px solid var(--accent-tint);
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.secret-activity-list div {
  display: flex;
  flex-direction: column;
}

.secret-activity-list strong {
  font-size: 0.82rem;
}

.secret-activity-list span,
.secret-activity-list time {
  color: var(--secondary-text-color);
  font-size: 0.68rem;
}

.secret-load-more {
  margin-top: 14px;
}

.secret-editor {
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: left;
}

.secret-editor > label,
.secret-form-grid > label,
.secret-retention-override,
.secret-policy-mode > label:not(.secret-mode-toggle),
.secret-delete-copy > label {
  display: flex;
  flex-direction: column;
  font-size: 0.84rem;
  font-weight: 600;
  gap: 5px;
}

.secret-editor input,
.secret-editor textarea,
.secret-policy-mode textarea,
.secret-delete-copy input {
  box-sizing: border-box;
  margin: 0;
  width: 100%;
}

.secret-editor small,
.secret-policy-mode small {
  color: var(--secondary-text-color);
  font-size: 0.7rem;
  font-weight: 400;
}

.secret-form-grid {
  align-items: end;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);
}

.secret-name-preview {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  display: flex;
  flex-direction: column;
  min-height: 42px;
  padding: 8px 10px;
}

.secret-name-preview code {
  font-size: 0.78rem;
  margin-top: 3px;
  overflow-wrap: anywhere;
}

.secret-warning,
.secret-notice,
.secret-error {
  border-radius: var(--radius-sm);
  font-size: 0.78rem;
  margin: 10px 0;
  padding: 9px 11px;
}

.secret-warning {
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
  color: var(--warning-text);
}

.secret-warning code {
  color: inherit;
  font-family: var(--font-mono);
}

.secret-notice {
  background: var(--accent-tint);
  border: 1px solid var(--border-color);
  color: var(--accent-tint-text);
}

.secret-error {
  background: var(--danger-bg);
  border: 1px solid var(--danger-text);
  color: var(--danger-text);
}

.secret-policy-editor {
  border: 0;
  margin: 0;
  padding: 0;
}

.secret-policy-editor legend {
  font-weight: 650;
  padding: 0;
}

.secret-policy-editor > p {
  font-size: 0.76rem;
  margin: 3px 0 9px;
}

.secret-policy-editor-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.secret-policy-mode {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  min-width: 0;
  padding: 11px;
}

.secret-mode-toggle {
  align-items: flex-start;
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.secret-mode-toggle input {
  flex: 0 0 auto;
  margin-top: 3px;
  width: auto;
}

.secret-mode-toggle span {
  display: flex;
  flex-direction: column;
}

.secret-modal-actions {
  border-top: 1px solid var(--border-color);
  justify-content: flex-end;
  padding-top: 13px;
}

.secret-modal-actions button {
  margin: 0;
  width: auto;
}

.secret-delete-copy {
  text-align: left;
}

.secret-delete-copy > p {
  color: var(--secondary-text-color);
  font-size: 0.83rem;
}

.secret-delete-copy .secret-modal-actions {
  margin-top: 16px;
}

.team-secrets button:focus-visible,
.team-secrets input:focus-visible,
.team-secrets textarea:focus-visible,
.team-secrets select:focus-visible,
.secret-editor button:focus-visible,
.secret-editor input:focus-visible,
.secret-editor textarea:focus-visible,
.secret-editor select:focus-visible,
.secret-delete-copy button:focus-visible,
.secret-delete-copy input:focus-visible {
  outline: 3px solid var(--accent-tint-text);
  outline-offset: 2px;
}

@media (max-width: 1080px) {
  .agent-secret-row {
    grid-template-columns: minmax(180px, 0.8fr) minmax(240px, 1.2fr);
  }

  .agent-secret-actions {
    grid-column: 1 / -1;
  }
  .secret-master-detail {
    display: block;
  }

  .secret-list-rail {
    border-bottom: 1px solid var(--border-color);
    border-right: 0;
    max-height: 380px;
    overflow-y: auto;
  }

  .secret-list {
    display: block;
  }

  .secret-list-item {
    grid-template-columns: minmax(200px, 1fr) minmax(220px, 1fr);
  }

  .secret-list-meta {
    align-items: flex-start;
    grid-column: 1 / -1;
    text-align: left;
  }
}

@media (max-width: 680px) {
  .team-secrets-header,
  .secret-detail-header,
  .secret-retention-row {
    align-items: stretch;
    flex-direction: column;
  }

  .team-secrets-header > button {
    width: 100%;
  }

  .agent-secrets-header-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .agent-secrets-header-actions button,
  .agent-secret-actions button {
    width: 100%;
  }

  .agent-secret-row,
  .secret-approval-comparison {
    grid-template-columns: 1fr;
  }

  .secret-search > div,
  .secret-modal-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .secret-search .lightButton,
  .secret-modal-actions button {
    width: 100%;
  }

  .secret-master-detail {
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    margin-left: -12px;
    margin-right: -12px;
  }

  .secret-master-detail.has-detail .secret-list-rail {
    display: none;
  }

  .secret-back-link {
    display: inline-block;
  }

  .secret-list {
    display: block;
  }

  .secret-list li,
  .secret-list li:nth-child(odd) {
    border-bottom: 1px solid var(--border-color);
    border-right: 0;
  }

  .secret-list-item {
    align-items: start;
    grid-template-columns: 1fr;
  }

  .secret-list-meta {
    grid-column: auto;
  }

  .secret-detail-ledger {
    padding: 14px 12px 20px;
  }

  .secret-detail-actions > button {
    flex: 1;
  }

  .secret-ledger-grid,
  .secret-form-grid,
  .secret-policy-editor-grid {
    grid-template-columns: 1fr;
  }

  .secret-policy-rail {
    grid-template-columns: 1fr;
  }

  .secret-policy-node,
  .secret-policy-state {
    border-left: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    border-right: 1px solid var(--border-color);
  }

  .secret-policy-track {
    border-left: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
  }

  .secret-policy-track::before,
  .secret-policy-track::after {
    display: none;
  }

  .secret-grant-control {
    grid-template-columns: 1fr;
  }

  .secret-grant-control label {
    grid-column: auto;
  }

  .secret-access-row {
    align-items: stretch;
    flex-direction: column;
  }

  .secret-section-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .secret-section-actions button {
    width: 100%;
  }

  .secret-activity-list li {
    align-items: start;
    grid-template-columns: auto minmax(0, 1fr);
  }

  .secret-activity-list time {
    grid-column: 2;
  }
}

@media (prefers-reduced-motion: reduce) {
  .secret-list-item,
  .secret-tabs button {
    scroll-behavior: auto;
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/secrets/Secrets.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,SAAS;AACX;;AAEA;;EAEE,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,SAAS;EACT,qEAAqE;EACrE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,SAAS;EACT,YAAY;AACd;;AAEA;;;;;;;EAOE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,0DAA0D;EAC1D,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,SAAS;EACT;;;KAGG;EACH,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;;;;EAOE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,4BAA4B;EAC5B,qCAAqC;EACrC,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;EAKE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,QAAQ;AACV;;AAEA;;EAEE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX;;;KAGG;EACH,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;;EAGE,4CAA4C;EAC5C,yCAAyC;EACzC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,oDAAoD;EACpD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,4CAA4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;;;;EAIE,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;EAGE,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,gEAAgE;EAClE;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,4CAA4C;IAC5C,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,OAAO;EACT;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0CAA0C;IAC1C,+BAA+B;IAC/B,2CAA2C;EAC7C;;EAEA;IACE,0CAA0C;IAC1C,2CAA2C;EAC7C;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,gBAAgB;EAClB;AACF","sourcesContent":[".team-secrets {\n  color: var(--text-color);\n  min-width: 0;\n}\n\n.team-secrets-header {\n  align-items: flex-end;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  gap: 24px;\n  justify-content: space-between;\n  margin-bottom: 18px;\n  padding-bottom: 16px;\n}\n\n.team-secrets-header h2,\n.secret-detail-header h3 {\n  font-family: var(--font-display);\n  margin: 2px 0 4px;\n}\n\n.team-secrets-header h2 {\n  font-size: 1.55rem;\n}\n\n.team-secrets-header p,\n.secret-detail-header p {\n  color: var(--secondary-text-color);\n  margin: 0;\n}\n\n.team-secrets-header > button,\n.secret-grant-control > button {\n  background: var(--button-primary-bg);\n  border: 1px solid var(--button-primary-bg);\n  border-radius: var(--radius-sm);\n  color: var(--button-primary-text);\n  cursor: pointer;\n  flex: 0 0 auto;\n  font-weight: 600;\n  padding: 9px 15px;\n}\n\n.agent-secrets-header-actions {\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n}\n\n.agent-secrets-header-actions button {\n  margin: 0;\n  width: auto;\n}\n\n.agent-secrets-header-actions button:not(.lightButton) {\n  background: var(--button-primary-bg);\n  border: 1px solid var(--button-primary-bg);\n  color: var(--button-primary-text);\n}\n\n.agent-secret-ledger {\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.agent-secret-row {\n  align-items: center;\n  background: var(--card-background);\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(180px, 0.8fr) minmax(280px, 1.4fr) auto;\n  padding: 16px;\n}\n\n.agent-secret-row + .agent-secret-row {\n  border-top: 1px solid var(--danger-border);\n}\n\n.agent-secret-identity {\n  min-width: 0;\n}\n\n.agent-secret-identity > a,\n.agent-secret-identity > .secret-name-button {\n  display: inline-block;\n  margin-right: 8px;\n  max-width: 100%;\n}\n\n.secret-name-button {\n  background: transparent;\n  border: 0;\n  color: var(--link-color);\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  width: auto;\n}\n\n.secret-name-button:hover code {\n  text-decoration: underline;\n}\n\n.agent-secret-identity code,\n.secret-approval-field code {\n  color: var(--text-color);\n  font-family: var(--font-mono);\n  font-weight: 650;\n  overflow-wrap: anywhere;\n}\n\n.agent-secret-identity p {\n  color: var(--secondary-text-color);\n  font-size: 0.82rem;\n  margin: 7px 0 0;\n}\n\n.agent-secret-policy {\n  display: grid;\n  gap: 7px;\n}\n\n.agent-secret-destination {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.agent-secret-actions button {\n  margin: 0;\n  white-space: nowrap;\n  width: auto;\n}\n\n.secret-approval-ledger {\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  display: grid;\n  gap: 10px;\n  margin: 12px 0;\n  padding: 12px;\n}\n\n.secret-approval-comparison {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.secret-approval-comparison > div {\n  background: var(--surface-2);\n  border-radius: var(--radius-sm);\n  display: grid;\n  gap: 8px;\n  padding: 10px;\n}\n\n.secret-approval-field > span {\n  color: var(--secondary-text-color);\n  display: block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.secret-approval-field p {\n  margin: 3px 0 0;\n  white-space: pre-wrap;\n}\n\n.secret-eyebrow {\n  color: var(--secondary-text-color);\n  display: block;\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n}\n\n.secret-search {\n  margin-bottom: 18px;\n}\n\n.secret-search label {\n  color: var(--secondary-text-color);\n  display: block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n\n.secret-search > div {\n  display: flex;\n  gap: 8px;\n}\n\n.secret-search input {\n  flex: 1;\n  margin: 0;\n  min-width: 0;\n}\n\n.secret-search .lightButton,\n.secret-row-actions .lightButton,\n.secret-row-actions .delete-button,\n.secret-detail-actions .lightButton,\n.secret-detail-actions .delete-button,\n.secret-access-row .lightButton,\n.secret-load-more {\n  margin: 0;\n  width: auto;\n}\n\n.secret-master-detail {\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  display: grid;\n  grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);\n  min-height: 510px;\n  overflow: hidden;\n}\n\n.secret-list-rail {\n  background: var(--card-background);\n  border-right: 1px solid var(--border-color);\n  min-width: 0;\n}\n\n.secret-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.secret-list-ledger {\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n\n.secret-list li + li {\n  border-top: 1px solid var(--border-color);\n}\n\n.secret-list-item {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  color: var(--text-color);\n  cursor: pointer;\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(220px, 1.25fr) minmax(240px, 1fr) minmax(\n      150px,\n      0.55fr\n    );\n  margin: 0;\n  padding: 16px;\n  text-align: left;\n  transition: background-color 150ms ease;\n  width: 100%;\n}\n\n.secret-list-item:hover {\n  background: var(--card-hover);\n}\n\n.secret-list-item.selected {\n  background: var(--accent-tint);\n}\n\n.secret-list-primary {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.secret-list-name,\n.secret-list-meta,\n.secret-destination-strip,\n.secret-row-actions,\n.secret-modal-actions,\n.secret-retention-row > span,\n.secret-retention-override > span {\n  align-items: center;\n  display: flex;\n}\n\n.secret-list-name {\n  gap: 8px;\n  justify-content: flex-start;\n  min-width: 0;\n  width: 100%;\n}\n\n.secret-list-meta {\n  align-items: flex-end;\n  flex-direction: column;\n  gap: 4px;\n  justify-content: center;\n  text-align: right;\n}\n\n.secret-list-name code,\n.secret-detail-header code,\n.secret-history-row code,\n.secret-name-preview code,\n.secret-policy-track code,\n.secret-ledger-grid code,\n.secret-version-table code {\n  color: var(--text-color);\n  font-family: var(--font-mono);\n}\n\n.secret-list-name code {\n  font-size: 0.84rem;\n  font-weight: 650;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.secret-version-chip,\n.secret-state-chip {\n  background: var(--surface-2);\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  color: var(--secondary-text-color);\n  font-family: var(--font-mono);\n  font-size: 0.67rem;\n  padding: 2px 7px;\n  white-space: nowrap;\n}\n\n.secret-state-chip.current {\n  background: var(--accent-tint);\n  color: var(--accent-tint-text);\n}\n\n.secret-alias-hint {\n  color: var(--link-color);\n  font-size: 0.72rem;\n}\n\n.secret-list-description {\n  color: var(--secondary-text-color);\n  display: -webkit-box;\n  font-size: 0.82rem;\n  line-height: 1.35;\n  overflow: hidden;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.secret-destination-strip {\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.secret-destination-chip {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  color: var(--secondary-text-color);\n  font-family: var(--font-mono);\n  font-size: 0.62rem;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 3px 7px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.secret-destination-chip b {\n  color: var(--text-color);\n  font-family: var(--font-body);\n  font-weight: 600;\n}\n\n.secret-list-meta {\n  color: var(--secondary-text-color);\n  font-family: var(--font-mono);\n  font-size: 0.62rem;\n  justify-content: center;\n  width: auto;\n}\n\n.secret-detail-ledger {\n  background: var(--background-color);\n  min-width: 0;\n  padding: 15px 18px 22px;\n}\n\n.secret-back-link {\n  background: transparent;\n  border: 0;\n  color: var(--link-color);\n  cursor: pointer;\n  display: none;\n  margin: 0 0 10px;\n  padding: 0;\n  width: auto;\n}\n\n.secret-detail-placeholder,\n.secret-state {\n  color: var(--secondary-text-color);\n}\n\n.secret-detail-placeholder {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 50px;\n  text-align: center;\n}\n\n.secret-detail-placeholder > span {\n  color: var(--border-strong);\n  font-family: var(--font-display);\n  font-size: 3rem;\n}\n\n.secret-detail-placeholder p {\n  max-width: 390px;\n}\n\n.secret-state {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n  padding: 28px 20px;\n  text-align: center;\n}\n\n.secret-detail-header {\n  align-items: flex-start;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n}\n\n.secret-detail-header h3 {\n  font-size: 1.2rem;\n}\n\n.secret-detail-header p {\n  font-size: 0.88rem;\n}\n\n.secret-detail-actions,\n.secret-modal-actions,\n.secret-row-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.secret-tabs {\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  gap: 2px;\n  margin-top: 18px;\n  overflow-x: auto;\n}\n\n.secret-tabs button {\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  border-radius: 0;\n  color: var(--secondary-text-color);\n  cursor: pointer;\n  flex: 0 0 auto;\n  font-size: 0.8rem;\n  margin: 0;\n  padding: 9px 10px 8px;\n  width: auto;\n}\n\n.secret-tabs button.active {\n  border-bottom-color: var(--link-color);\n  color: var(--text-color);\n  font-weight: 600;\n}\n\n.secret-detail-body {\n  min-width: 0;\n  padding-top: 18px;\n}\n\n.secret-ledger-grid {\n  display: grid;\n  gap: 0;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin: 0;\n}\n\n.secret-ledger-grid > div {\n  border-bottom: 1px solid var(--border-color);\n  min-width: 0;\n  padding: 12px;\n}\n\n.secret-ledger-grid dt,\n.secret-policy-node span,\n.secret-policy-state span,\n.secret-history-row > span,\n.secret-name-preview span {\n  color: var(--secondary-text-color);\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.secret-ledger-grid dd {\n  font-size: 0.88rem;\n  margin: 4px 0 0;\n  overflow-wrap: anywhere;\n}\n\n.secret-history-row {\n  align-items: center;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 13px 12px;\n}\n\n.secret-history-row code {\n  background: var(--card-background);\n  border-radius: var(--radius-sm);\n  font-size: 0.72rem;\n  padding: 4px 7px;\n}\n\n.secret-retention-row {\n  align-items: center;\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  display: flex;\n  gap: 18px;\n  justify-content: space-between;\n  margin-top: 24px;\n  padding: 14px;\n}\n\n.secret-retention-row label {\n  font-weight: 600;\n}\n\n.secret-retention-row p {\n  color: var(--secondary-text-color);\n  font-size: 0.76rem;\n  margin: 3px 0 0;\n}\n\n.secret-retention-row > span,\n.secret-retention-override > span {\n  color: var(--secondary-text-color);\n  gap: 7px;\n}\n\n.secret-retention-row input,\n.secret-retention-override input {\n  margin: 0;\n  width: 88px;\n}\n\n.secret-policy-rail {\n  display: grid;\n  gap: 12px 0;\n  grid-template-columns: minmax(112px, 0.7fr) minmax(180px, 2fr) minmax(\n      130px,\n      1fr\n    );\n  margin-top: 20px;\n  position: relative;\n}\n\n.secret-section-actions {\n  align-items: center;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  display: flex;\n  gap: 18px;\n  justify-content: space-between;\n  margin-bottom: 18px;\n  padding: 14px;\n}\n\n.secret-danger-zone {\n  border-top: 1px solid var(--border-color);\n  margin-top: 40px;\n  padding-top: 20px;\n}\n\n.secret-danger-zone-heading {\n  margin: 0 0 10px;\n  color: var(--danger-text);\n}\n\n.secret-danger-zone p {\n  margin: 0 0 14px;\n  max-width: 620px;\n}\n\n.secret-danger-zone button {\n  margin: 0;\n  width: auto;\n}\n\n.secret-policy-node,\n.secret-policy-track,\n.secret-policy-state {\n  border-bottom: 1px solid var(--border-color);\n  border-top: 1px solid var(--border-color);\n  min-width: 0;\n  padding: 13px;\n}\n\n.secret-policy-node {\n  background: var(--accent-tint);\n  border-left: 1px solid var(--border-color);\n  border-radius: var(--radius-sm) 0 0 var(--radius-sm);\n  display: flex;\n  flex-direction: column;\n}\n\n.secret-policy-node strong {\n  color: var(--accent-tint-text);\n}\n\n.secret-policy-node em {\n  color: var(--secondary-text-color);\n  font-size: 0.7rem;\n  font-style: normal;\n  margin-top: 3px;\n}\n\n.secret-policy-track {\n  align-items: flex-start;\n  background: var(--card-background);\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  position: relative;\n}\n\n.secret-policy-track::before,\n.secret-policy-track::after {\n  background: var(--border-strong);\n  content: '';\n  height: 1px;\n  position: absolute;\n  top: 50%;\n  width: 12px;\n}\n\n.secret-policy-track::before {\n  left: -1px;\n}\n.secret-policy-track::after {\n  right: -1px;\n}\n\n.secret-policy-track code {\n  background: var(--background-color);\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  font-size: 0.7rem;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 4px 8px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.secret-policy-state {\n  border-right: 1px solid var(--border-color);\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.secret-policy-state strong {\n  font-family: var(--font-mono);\n  font-size: 0.72rem;\n  margin-top: 3px;\n}\n\n.secret-grant-control {\n  align-items: end;\n  border-bottom: 1px solid var(--border-color);\n  display: grid;\n  gap: 7px;\n  grid-template-columns: minmax(0, 1fr) auto;\n  padding-bottom: 16px;\n}\n\n.secret-grant-control label {\n  grid-column: 1 / -1;\n  font-weight: 600;\n}\n\n.secret-grant-control select {\n  min-width: 0;\n}\n\n.secret-access-row {\n  align-items: center;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  padding: 13px 0;\n}\n\n.secret-access-row > div {\n  display: flex;\n  flex-direction: column;\n}\n\n.secret-access-row span {\n  color: var(--secondary-text-color);\n  font-size: 0.75rem;\n}\n\n.secret-version-table-wrap {\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.secret-version-table {\n  border-collapse: collapse;\n  font-size: 0.74rem;\n  min-width: 790px;\n  width: 100%;\n}\n\n.secret-version-table th,\n.secret-version-table td {\n  border-bottom: 1px solid var(--border-color);\n  padding: 10px 8px;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.secret-version-table th {\n  color: var(--secondary-text-color);\n  font-size: 0.65rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.secret-version-table td:last-child {\n  text-align: right;\n}\n\n.secret-row-actions {\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n}\n\n.secret-row-actions button {\n  font-size: 0.68rem;\n  padding: 5px 8px;\n}\n\n.secret-activity-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.secret-activity-list li {\n  align-items: center;\n  border-bottom: 1px solid var(--border-color);\n  display: grid;\n  gap: 10px;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  padding: 11px 4px;\n}\n\n.secret-activity-mark {\n  background: var(--link-color);\n  border: 3px solid var(--accent-tint);\n  border-radius: 50%;\n  height: 10px;\n  width: 10px;\n}\n\n.secret-activity-list div {\n  display: flex;\n  flex-direction: column;\n}\n\n.secret-activity-list strong {\n  font-size: 0.82rem;\n}\n\n.secret-activity-list span,\n.secret-activity-list time {\n  color: var(--secondary-text-color);\n  font-size: 0.68rem;\n}\n\n.secret-load-more {\n  margin-top: 14px;\n}\n\n.secret-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  text-align: left;\n}\n\n.secret-editor > label,\n.secret-form-grid > label,\n.secret-retention-override,\n.secret-policy-mode > label:not(.secret-mode-toggle),\n.secret-delete-copy > label {\n  display: flex;\n  flex-direction: column;\n  font-size: 0.84rem;\n  font-weight: 600;\n  gap: 5px;\n}\n\n.secret-editor input,\n.secret-editor textarea,\n.secret-policy-mode textarea,\n.secret-delete-copy input {\n  box-sizing: border-box;\n  margin: 0;\n  width: 100%;\n}\n\n.secret-editor small,\n.secret-policy-mode small {\n  color: var(--secondary-text-color);\n  font-size: 0.7rem;\n  font-weight: 400;\n}\n\n.secret-form-grid {\n  align-items: end;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);\n}\n\n.secret-name-preview {\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  display: flex;\n  flex-direction: column;\n  min-height: 42px;\n  padding: 8px 10px;\n}\n\n.secret-name-preview code {\n  font-size: 0.78rem;\n  margin-top: 3px;\n  overflow-wrap: anywhere;\n}\n\n.secret-warning,\n.secret-notice,\n.secret-error {\n  border-radius: var(--radius-sm);\n  font-size: 0.78rem;\n  margin: 10px 0;\n  padding: 9px 11px;\n}\n\n.secret-warning {\n  background: var(--warning-bg);\n  border: 1px solid var(--warning-border);\n  color: var(--warning-text);\n}\n\n.secret-warning code {\n  color: inherit;\n  font-family: var(--font-mono);\n}\n\n.secret-notice {\n  background: var(--accent-tint);\n  border: 1px solid var(--border-color);\n  color: var(--accent-tint-text);\n}\n\n.secret-error {\n  background: var(--danger-bg);\n  border: 1px solid var(--danger-text);\n  color: var(--danger-text);\n}\n\n.secret-policy-editor {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.secret-policy-editor legend {\n  font-weight: 650;\n  padding: 0;\n}\n\n.secret-policy-editor > p {\n  font-size: 0.76rem;\n  margin: 3px 0 9px;\n}\n\n.secret-policy-editor-grid {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.secret-policy-mode {\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  min-width: 0;\n  padding: 11px;\n}\n\n.secret-mode-toggle {\n  align-items: flex-start;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.secret-mode-toggle input {\n  flex: 0 0 auto;\n  margin-top: 3px;\n  width: auto;\n}\n\n.secret-mode-toggle span {\n  display: flex;\n  flex-direction: column;\n}\n\n.secret-modal-actions {\n  border-top: 1px solid var(--border-color);\n  justify-content: flex-end;\n  padding-top: 13px;\n}\n\n.secret-modal-actions button {\n  margin: 0;\n  width: auto;\n}\n\n.secret-delete-copy {\n  text-align: left;\n}\n\n.secret-delete-copy > p {\n  color: var(--secondary-text-color);\n  font-size: 0.83rem;\n}\n\n.secret-delete-copy .secret-modal-actions {\n  margin-top: 16px;\n}\n\n.team-secrets button:focus-visible,\n.team-secrets input:focus-visible,\n.team-secrets textarea:focus-visible,\n.team-secrets select:focus-visible,\n.secret-editor button:focus-visible,\n.secret-editor input:focus-visible,\n.secret-editor textarea:focus-visible,\n.secret-editor select:focus-visible,\n.secret-delete-copy button:focus-visible,\n.secret-delete-copy input:focus-visible {\n  outline: 3px solid var(--accent-tint-text);\n  outline-offset: 2px;\n}\n\n@media (max-width: 1080px) {\n  .agent-secret-row {\n    grid-template-columns: minmax(180px, 0.8fr) minmax(240px, 1.2fr);\n  }\n\n  .agent-secret-actions {\n    grid-column: 1 / -1;\n  }\n  .secret-master-detail {\n    display: block;\n  }\n\n  .secret-list-rail {\n    border-bottom: 1px solid var(--border-color);\n    border-right: 0;\n    max-height: 380px;\n    overflow-y: auto;\n  }\n\n  .secret-list {\n    display: block;\n  }\n\n  .secret-list-item {\n    grid-template-columns: minmax(200px, 1fr) minmax(220px, 1fr);\n  }\n\n  .secret-list-meta {\n    align-items: flex-start;\n    grid-column: 1 / -1;\n    text-align: left;\n  }\n}\n\n@media (max-width: 680px) {\n  .team-secrets-header,\n  .secret-detail-header,\n  .secret-retention-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .team-secrets-header > button {\n    width: 100%;\n  }\n\n  .agent-secrets-header-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .agent-secrets-header-actions button,\n  .agent-secret-actions button {\n    width: 100%;\n  }\n\n  .agent-secret-row,\n  .secret-approval-comparison {\n    grid-template-columns: 1fr;\n  }\n\n  .secret-search > div,\n  .secret-modal-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .secret-search .lightButton,\n  .secret-modal-actions button {\n    width: 100%;\n  }\n\n  .secret-master-detail {\n    border-left: 0;\n    border-right: 0;\n    border-radius: 0;\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n\n  .secret-master-detail.has-detail .secret-list-rail {\n    display: none;\n  }\n\n  .secret-back-link {\n    display: inline-block;\n  }\n\n  .secret-list {\n    display: block;\n  }\n\n  .secret-list li,\n  .secret-list li:nth-child(odd) {\n    border-bottom: 1px solid var(--border-color);\n    border-right: 0;\n  }\n\n  .secret-list-item {\n    align-items: start;\n    grid-template-columns: 1fr;\n  }\n\n  .secret-list-meta {\n    grid-column: auto;\n  }\n\n  .secret-detail-ledger {\n    padding: 14px 12px 20px;\n  }\n\n  .secret-detail-actions > button {\n    flex: 1;\n  }\n\n  .secret-ledger-grid,\n  .secret-form-grid,\n  .secret-policy-editor-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .secret-policy-rail {\n    grid-template-columns: 1fr;\n  }\n\n  .secret-policy-node,\n  .secret-policy-state {\n    border-left: 1px solid var(--border-color);\n    border-radius: var(--radius-sm);\n    border-right: 1px solid var(--border-color);\n  }\n\n  .secret-policy-track {\n    border-left: 1px solid var(--border-color);\n    border-right: 1px solid var(--border-color);\n  }\n\n  .secret-policy-track::before,\n  .secret-policy-track::after {\n    display: none;\n  }\n\n  .secret-grant-control {\n    grid-template-columns: 1fr;\n  }\n\n  .secret-grant-control label {\n    grid-column: auto;\n  }\n\n  .secret-access-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .secret-section-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .secret-section-actions button {\n    width: 100%;\n  }\n\n  .secret-activity-list li {\n    align-items: start;\n    grid-template-columns: auto minmax(0, 1fr);\n  }\n\n  .secret-activity-list time {\n    grid-column: 2;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .secret-list-item,\n  .secret-tabs button {\n    scroll-behavior: auto;\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
